import { CreditNoteReasonFlowData, CreditNoteReasonFlowStep } from "core/api";
import { StepDataResolver } from "../models";

/**
 * Credit Note Reason data resolver
 *
 * Formats Credit Note Reason based on form field values
 */
export const creditNoteReasonDataResolver: StepDataResolver<
  CreditNoteReasonFlowStep,
  CreditNoteReasonFlowData
> = ({ data, fieldValues }) => {
  return {
    text: fieldValues.text ?? data.text,
    creditReason:
      data.creditReasons.find(
        (reason) => reason.id === fieldValues.creditReason
      ) ?? data.creditReason,
  };
};
